import styled from '../../../theme'

const PageWrapper = styled.div<{ height?: string | number }>`
  width: 100%;
  ${({ height }) =>
    height != null &&
    height !== '' &&
    `height: ${typeof height === 'number' ? `${height}px` : height};`}
`

export default PageWrapper
